<script setup lang="ts">
import ContactForm from "@/contacts/ContactForm.vue";
import { useUpdateContact } from "./contactsCrud";
import type { ContactQuery } from "./types";

const props = defineProps<{
  contactDetails: ContactQuery;
}>();

const { updateContact, updateContactStatus } = useUpdateContact();
</script>

<template>
  <ContactForm
    :contact-details="props.contactDetails"
    :update-contact-status="updateContactStatus"
    @update="updateContact"
  />
</template>
